
import { defineComponent } from "vue";
import { Month, WeekDayShort } from "@/common/constants";

import { addDays } from "date-fns";

export default defineComponent({
  name: "DatePicker",
  data() {
    const current_date = this.modelValue || new Date();
    const current_month_text = Month[current_date.getMonth()][1];
    const current_wd_text = WeekDayShort[current_date.getDay()];
    const offset_date = new Date(
      current_date.getFullYear(),
      current_date.getMonth()
    );
    const four_two = this.getSixWeeks(offset_date, current_date);
    const offset_month_year =
      Month[offset_date.getMonth()][0] + " de " + offset_date.getFullYear();

    const months = [];

    for (let i = 0; i < Month.length; i++)
      months.push({ nome: Month[i][0], i });
    const decade_start = 0;
    const decade_end = 0;

    return {
      current_date,
      current_month_text,
      current_wd_text,
      four_two,
      offset_date,
      offset_month_year,
      visible: false,
      show_months: false,
      show_years: false,
      months,
      ten_years: [] as number[],
      decade_start,
      decade_end,
      validation_message: undefined as string | undefined,
    };
  },
  props: {
    modelValue: Date,
    name: String,
    label: String,
    validation: Object,
    required: Boolean,
    disabled: Boolean,
  },
  watch: {
    modelValue(n) {
      if (n) this.setNewCurrentDate(n);
    },
  },
  emits: ["update:modelValue", "updateValidation"],
  computed: {
    date_text() {
      if (!this.modelValue) return "";
      return this.current_date.toLocaleDateString();
    },
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.validate();
    },
    validate() {
      if (this.required && !this.date_text)
        this.validation_message = "Seleção obrigatória";
      else this.validation_message = undefined;
      this.$emit(
        "updateValidation",
        this.name,
        !!this.date_text || !this.required
      );
    },
    getSixWeeks(offset_date: any, current_date: any) {
      const days = [];
      const today = new Date();

      let d = addDays(offset_date, -offset_date.getDay() - 1);
      for (let i = 0; i < 42; i++) {
        d = addDays(d, 1);
        days[i] = {
          date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
          outMonth: d.getMonth() != offset_date.getMonth(),
          isToday:
            today.getDate() == d.getDate() &&
            today.getMonth() == d.getMonth() &&
            today.getFullYear() == d.getFullYear(),
          isSelected:
            current_date.getDate() == d.getDate() &&
            current_date.getMonth() == d.getMonth() &&
            current_date.getFullYear() == d.getFullYear(),
        };
      }

      return days;
    },
    setNewCurrentDate(new_date: Date) {
      this.current_date = new_date;
      this.current_month_text = Month[new_date.getMonth()][1];
      this.current_wd_text = WeekDayShort[new_date.getDay()];
      this.offset_date = new Date(new_date.getFullYear(), new_date.getMonth());
      this.four_two = this.getSixWeeks(this.offset_date, new_date);
      this.offset_month_year =
        Month[this.offset_date.getMonth()][0] +
        " de " +
        this.offset_date.getFullYear();

      this.hide();
      this.$emit("update:modelValue", new_date);
    },
    setOffsetDateMonth(offset: number) {
      this.offset_date.setMonth(this.offset_date.getMonth() + offset);
      this.four_two = this.getSixWeeks(this.offset_date, this.current_date);
      this.offset_month_year =
        Month[this.offset_date.getMonth()][0] +
        " de " +
        this.offset_date.getFullYear();
    },
    setOffsetDateYear(offset: number) {
      this.offset_date = new Date(
        this.offset_date.getFullYear() + offset,
        this.offset_date.getMonth()
      );
      this.four_two = this.getSixWeeks(this.offset_date, this.current_date);
    },
    setDateOffsetMonth(m: number) {
      this.offset_date.setMonth(m);
      this.four_two = this.getSixWeeks(this.offset_date, this.current_date);
      this.offset_month_year =
        Month[this.offset_date.getMonth()][0] +
        " de " +
        this.offset_date.getFullYear();

      this.show_months = false;
    },
    setDateOffsetYear(y: number) {
      this.offset_date.setFullYear(y);
      this.four_two = this.getSixWeeks(this.offset_date, this.current_date);
      this.getTenYears();

      this.show_years = false;
    },
    getTenYears() {
      let decade_start = 0;
      let decade_end = 0;
      if (!this.show_years) {
        decade_end = new Date().getFullYear();
        decade_start = decade_end - 10;
        const offset_year = this.offset_date.getFullYear();
        while (offset_year <= decade_start || offset_year > decade_end) {
          if (offset_year <= decade_start) {
            decade_end = decade_start;
            decade_start -= 10;
          }
          if (offset_year > decade_end) {
            decade_start = decade_end;
            decade_end += 10;
          }
        }
        this.decade_start = decade_start + 1;
        this.decade_end = decade_end;
      } else {
        decade_start = this.decade_start;
        decade_end = this.decade_end;
      }

      const years = [];
      for (++decade_start; decade_start <= decade_end; decade_start++) {
        years.push(decade_start);
      }

      this.ten_years = years;
    },
  },
});
